import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _QuizTitleShow;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@instructure/emotion';
import { TruncateText } from '@instructure/ui-truncate-text';
import { Text } from '@instructure/ui-text';
import Overlay from '../../../../../../common/components/shared/overlay';
import makeScrollable from '../../../../../../common/components/shared/functionality/makeScrollable';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';

// ====================================

// this component shows the quiz title
// has events that allow for toggling
// editing and hover which shows an
// overlay

// ====================================
export var QuizTitleShow = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_QuizTitleShow = /*#__PURE__*/function (_Component) {
  function QuizTitleShow() {
    var _this2;
    _classCallCheck(this, QuizTitleShow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, QuizTitleShow, [].concat(args));
    _defineProperty(_this2, "switchOnEditing", function () {
      _this2.props.switchOnEditing();
    });
    return _this2;
  }
  _inherits(QuizTitleShow, _Component);
  return _createClass(QuizTitleShow, [{
    key: "render",
    value: function render() {
      return jsx("span", {
        "data-automation": "sdk-quiz-title-show-wrapper"
      }, jsx(Overlay, {
        wrapperStyles: this.props.styles.titleShowWrapper,
        onClick: this.switchOnEditing,
        tabIndex: "-1",
        hideOverlay: this.props.contentLocked
      }, jsx(Text, {
        color: "primary",
        size: "x-large"
      }, jsx("span", {
        "data-automation": "sdk-quiz-title-show-title"
      }, jsx(TruncateText, null, this.props.defaultTitle)))));
    }
  }]);
}(Component), _defineProperty(_QuizTitleShow, "displayName", 'QuizTitleShow'), _defineProperty(_QuizTitleShow, "componentId", "Quizzes".concat(_QuizTitleShow.displayName)), _defineProperty(_QuizTitleShow, "propTypes", {
  defaultTitle: PropTypes.string.isRequired,
  switchOnEditing: PropTypes.func.isRequired,
  contentLocked: PropTypes.bool,
  styles: PropTypes.object
}), _defineProperty(_QuizTitleShow, "defaultProps", {
  contentLocked: false
}), _QuizTitleShow)) || _class);
export default makeScrollable(QuizTitleShow);